import { ApolloLink, Observable } from "@apollo/client";
export default function createKillswitchLink() {
    const killswitchedOperations = new Set();
    return new ApolloLink(function killswitchLink(operation, forward) {
        if (killswitchedOperations.has(operation.operationName)) {
            return new Observable((observer)=>{
                const error = {
                    message: 'Killswitched request',
                    name: 'Killswitched request',
                    path: [],
                    extensions: {
                        actionId: null,
                        traceId: null,
                        error: {
                            code: 'killswitch_error',
                            source: 'client',
                            status: -1
                        },
                        unstable_requestId: null
                    },
                    nodes: undefined,
                    source: undefined,
                    positions: undefined,
                    originalError: undefined,
                    locations: undefined
                };
                observer.next({
                    data: null,
                    errors: [
                        error
                    ]
                });
                observer.complete();
            });
        }
        return new Observable(function killswitchObserver(observer) {
            const subscription = forward(operation).subscribe({
                next: function killswitchLinkNext(result) {
                    const context = operation.getContext();
                    var _context_responses, _ref;
                    const responses = (_ref = (_context_responses = context.responses) !== null && _context_responses !== void 0 ? _context_responses : context.response && [
                        context.response
                    ]) !== null && _ref !== void 0 ? _ref : [];
                    responses.forEach((response)=>{
                        var _response_headers_get, _response_headers;
                        const killswitchHeader = response === null || response === void 0 ? void 0 : (_response_headers = response.headers) === null || _response_headers === void 0 ? void 0 : (_response_headers_get = _response_headers.get) === null || _response_headers_get === void 0 ? void 0 : _response_headers_get.call(_response_headers, 'X-Request-Killswitch');
                        if (killswitchHeader) {
                            const operationsToKillswitch = killswitchHeader.trim().split(/\s*,\s*/);
                            operationsToKillswitch.forEach((name)=>{
                                if (name) {
                                    killswitchedOperations.add(name);
                                }
                            });
                        }
                    });
                    return observer.next(result);
                },
                error: function killswitchLinkError(error) {
                    return observer.error(error);
                },
                complete: function killswitchLinkComplete() {
                    return observer.complete();
                }
            });
            return function killswitchLinkUnsubscribe() {
                if (subscription) {
                    subscription.unsubscribe();
                }
            };
        });
    });
}

//# sourceMappingURL=createKillswitchLink.js.map